<div class="modal-header">
	<h4 class="modal-title">Lisää uusi tagi</h4>
	<button
		type="button"
		class="btn-close"
		aria-label="Close"
		(click)="close()"
	></button>
</div>

<div class="modal-body">
	<div class="row g-3">
		<div class="col-md-12">
			<label for="newTagName" class="form-label">Nimi</label>
			<div class="input-group mb-3">
				<span class="input-group-text" id="hashtag">#</span>
				<input
					type="text"
					id="newTagName"
					class="form-control"
					[(ngModel)]="newTag.Name"
					placeholder="Syötä tagin nimi..."
					(keyup.enter)="addNewTag()"
					[disabled]="isAddingTag"
				/>
			</div>
		</div>
		<div class="col-md-12">
			<label for="newTagDescription" class="form-label">Kuvaus</label>
			<input
				type="text"
				id="newTagDescription"
				class="form-control"
				[(ngModel)]="newTag.Description"
				placeholder="Syötä tagin kuvaus..."
				(keyup.enter)="addNewTag()"
				[disabled]="isAddingTag"
			/>
		</div>
	</div>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-secondary" (click)="close()">
		Peruuta
	</button>
	<button
		type="button"
		class="btn btn-primary"
		(click)="addNewTag()"
		[disabled]="!newTag.Name.trim() || isAddingTag"
	>
		<span
			*ngIf="isAddingTag"
			class="spinner-border spinner-border-sm me-2"
			role="status"
			aria-hidden="true"
		></span>
		<i *ngIf="!isAddingTag" class="bi bi-plus"></i> Lisää tagi
	</button>
</div>
